"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.imgTool = void 0;
const zod_1 = require("zod");
exports.imgTool = {
    name: 'imgGen',
    description: `Generate images from text prompts only on specific user request.
    Use this tool when the user explicitly asks for image generation based on a text description.
    Do not use this tool for general queries or non-image related requests.`,
    zodSchema: zod_1.z.object({
        prompt: zod_1.z.string().describe('The image generation prompt describing what image to create. Must be in english.')
    }),
    blockStream: true
};
